<template>
  <div>
    <div
      v-if="title"
      class="c-select_wrap__text-title-sp">
      {{ title }}
    </div>
    <div class="select-container">
      <div
        class="c-select_wrap__text-title">
        {{ title }}
      </div>
      <span class="form-item__wrap">
        <div class="c-select_wrap">
          <select
            v-model="year"
            :disabled="disabled"
            class="form-control c-select"
            @change.prevent="onChangeDate">
            <option
              v-for="val in years"
              :key="`year-${val}`"
              :value="val"> {{ val }}
            </option>
          </select>
        </div>
        <span class="c-select_wrap__text">年</span>
      </span>
      <span class="form-item__wrap">
        <div class="c-select_wrap">
          <select
            v-model="month"
            :disabled="disabled"
            class="form-control c-select"
            @change.prevent="onChangeDate">
            <option
              v-for="val in 12"
              :key="`month-${val}`"
              :value="zeroPadding(val)"> {{ val }}
            </option>
          </select>
        </div>
        <span class="c-select_wrap__text">月</span>
      </span>
      <span class="form-item__wrap">
        <div class="c-select_wrap">
          <select
            v-model="date"
            :disabled="disabled"
            class="form-control c-select"
            @change.prevent="onChangeDate">
            <option v-if="!endOfTheMonth">&nbsp; &nbsp; &nbsp;</option>
            <option
              v-for="val in endOfTheMonth"
              :key="`day-${val}`"
              :value="zeroPadding(val)">
              {{ val }}
            </option>
          </select>
        </div>
        <span class="c-select_wrap__text">日{{ suffix }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'DateSelect',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    suffix: {
      type: String,
      required: false,
      default: () => '',
    },
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    value: {
      type: [String, Object],
      required: true,
    },
    minDate: {
      type: [String, Object],
      default: () => '1970-01-01',
    },
    maxDate: {
      type: String,
      default: () => moment().format('YYYY-MM-DD'),
    },
    // falseならばvalueが空の時にデフォルトの日付をセットしない
    isSelected: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      year: '',
      month: '',
      date: '',
      endOfTheMonth: '',
    }
  },
  computed: {
    // 選択可能な年配列
    years() {
      let min = moment(new Date(this.minDate))
      let max = moment(new Date(this.maxDate))

      const defaultDate = moment(new Date(this.value))
      const defaultYear = defaultDate.year()
      if (min.year() > defaultYear) {
        min = defaultDate
      }
      if (max.year() < defaultYear) {
        max = defaultDate
      }
      const years = []
      for (let year = min.year(); year <= max.year(); year += 1) {
        years.push(year)
      }
      return years
    },
  },
  watch: {
    value() {
      const date = moment(new Date(this.value))
      const endOfTheMonth = date.clone()
      if (endOfTheMonth.isValid()) {
        this.endOfTheMonth = endOfTheMonth.endOf('M').date()
      }
      this.year = date.year()
      this.month = this.zeroPadding(date.month() + 1)
      this.date = this.zeroPadding(date.date())
    },
  },
  mounted() {
    if (this.isSelected) {
      const date = this.value
        ? moment(this.value)
        : moment(new Date(this.maxDate))
      this.year = date.year()
      this.month = this.zeroPadding(date.month() + 1)
      this.date = this.zeroPadding(date.date())
      this.$emit('input', date.format('YYYY-MM-DD'))
      const endOfTheMonth = date.clone()
      if (endOfTheMonth.isValid()) {
        this.endOfTheMonth = endOfTheMonth.endOf('M').date()
      }
    }
  },
  methods: {
    zeroPadding(str) {
      return `00${str}`.slice(-2)
    },
    onChangeDate() {
      let date = moment(new Date(`${this.year}-${this.month}-${this.date}`))
      if (!date) {
        return
      }
      // デフォルト値を設定しない場合、年月日が揃っていない不正な日付になる事があるのでチェック
      if (!this.isSelected && (!this.year || !this.month || !this.date)) {
        if (!this.year || !this.month) {
          return
        }
        // 日だけが無い場合は1日を追加
        if (this.year && this.month && !this.date) {
          this.date = '01'
        }
        // 日付を再計算
        date = moment(new Date(`${this.year}-${this.month}-${this.date}`))
        // 日付が不正ならば何もしない
        if (!date.isValid()) {
          return
        }
      }
      const min = moment(new Date(this.minDate))
      const max = moment(new Date(this.maxDate))
      if (!date.isValid()) {
        date = min
      } else if (date.unix() <= min.unix()) {
        date = min
      } else if (date.unix() >= max.unix()) {
        date = max
      }
      const endOfTheMonth = date.clone()
      this.endOfTheMonth = endOfTheMonth.endOf('M').date()
      this.$emit('input', date.format('YYYY-MM-DD'))
      this.year = date.year()
      this.month = this.zeroPadding(date.month() + 1)
      this.date = this.zeroPadding(date.date())
    },
  },
}
</script>

<style scoped>
.select-container{
  display: flex;
  gap: 15px;
}
.form-item__wrap {
  margin: 0px;
  padding: 0px;
  display: flex;
  align-items: baseline;
}
</style>
